"use client";
import React from "react";
import CrewSubpage from "../../components/crews/CrewSubpage";

export default function EBooksCrewPage() {
  return <CrewSubpage data-component-id="src/app/ebooks-crew/page.tsx:6:9" data-component-path="src/app/ebooks-crew/page.tsx" data-component-line="6" data-component-end-line="6" data-component-file="page.tsx" data-component-name="CrewSubpage" data-component-content="%7B%22elementName%22%3A%22CrewSubpage%22%7D" slug="ebooks" />;
}
